/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { debounceTime, filter, map } from 'rxjs/operators';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { UNITS_DEFAULT_SORT_COLUMN, UNITS_DEFAULT_SORT_COLUMN_DIRECTION, UNITS_PAGE_DEFAULT_SIZE, UNITS_PAGE_SIZE_OPTIONS, UNITS_TABLE_HEADER } from 'src/app/conf/mtma-units';
import { MtmaContactUnit, MtmaUnit } from 'src/app/model/mtma-unit';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { selectMtmaActiveTask, selectMtmaUnitModify, selectMtmaUnits, selectMtmaUnitsMaxData, selectMtmaUnitsPagination } from 'src/app/store/device/device.selector';
import { ItemsPagination, MtmaMaxData } from 'src/app/model/api/data-rest';
import { MtmaTask } from 'src/app/model/mtma-task';
import { TableLazyLoadEvent } from 'primeng/table';
import { pageSortChange } from 'src/app/services/table';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MtmaUnitDialogComponent } from '../mtma-manage-unit-dialog/mtma-manage-unit-dialog.component';
import { StandardMtmaLayout, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectDeviceTabIndex } from 'src/app/store/home/home.selector';

@Component({
    selector: 'app-mtma-manage-unit',
    templateUrl: './mtma-manage-unit.component.html',
    providers: [ConfirmationService, DialogService]
})


export class MtmaManageUnitComponent implements OnInit, OnDestroy {
    mtmaUnits$: Observable<MtmaUnit[] | undefined>;
    mtmaUnitsSub: Subscription | undefined;
    mtmaUnitsPagination$: Observable<ItemsPagination | undefined>;
    mtmaUnitsPaginationSub: Subscription | undefined;
    mtmaUnitsMaxData$: Observable<MtmaMaxData | undefined>;
    mtmaUnitsMaxDataSub: Subscription | undefined;
    mtmaUnitModify$: Observable<boolean | undefined>;
    mtmaUnitModifySub: Subscription | undefined;
    mtmaActiveTask$: Observable<MtmaTask | undefined>;
    mtmaActiveTaskSub: Subscription | undefined;
    tabIndex: number;
    tabIndex$: Observable<number | undefined>;
    tabIndexSub: Subscription | undefined;

    expandedRows = {};


    mtmaUnits: MtmaUnit[];
    unitssLoading: boolean;

    searchFilter: FormControl = new FormControl('');
    filterSub: Subscription;
    filter: '';

    columns = UNITS_TABLE_HEADER;
    paging: PaginationParams = {
        size: UNITS_PAGE_DEFAULT_SIZE,
        page: 1,
        sort: UNITS_DEFAULT_SORT_COLUMN,
        order: UNITS_DEFAULT_SORT_COLUMN_DIRECTION,
    };
    pageSize: number = UNITS_PAGE_DEFAULT_SIZE;
    pageSizeOptions = UNITS_PAGE_SIZE_OPTIONS;
    totalRecords: number;

    memorySize = 1;
    maxMemorySize = 1;

    isActiveTask = false;
    dateTransform: DatePipe;

    ref: DynamicDialogRef | undefined;

    acceptButtonStyle: string;
    rejectButtonStyle: string;

    // Design
    screenWidth: number;
    MIN_MD_WIDTH = 500;
    COLUMN_TITLE_MIN_WD = 967;
    MAX_MD_WIDTH = 1120;
    MIN_WIDTH_MX7 = 1700;
    LG_WIDTH = 1500;

    MAX_MD_WIDTH_SHORT = 858;

    constructor(
        //private dialog: MatDialog,
        private store: Store<AppState>,
        public confirmationService: ConfirmationService,
        private translate: TranslateService,
        public dialogService: DialogService,
    ) {
        this.initSelectors();
    }

    initSelectors(): void {
        this.mtmaUnits$ = this.store.select(selectMtmaUnits);
        this.mtmaUnitsPagination$ = this.store.select(selectMtmaUnitsPagination);
        this.mtmaUnitsMaxData$ = this.store.select(selectMtmaUnitsMaxData);
        this.mtmaUnitModify$ = this.store.select(selectMtmaUnitModify);
        this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
        this.tabIndex$ = this.store.select(selectDeviceTabIndex);
    }

    ngOnInit(): void {
        const curreLang = this.translate.currentLang;
        this.dateTransform = new DatePipe(curreLang);
        this.filterSub = this.searchFilter.valueChanges.pipe(
            debounceTime(500),
            map(v => v.trim().toLowerCase())
        ).subscribe(value => {
            this.filter = value;
            this.dispatchGetUnits();
        });
        this.dispatchGetUnits();
        this.store.dispatch(DeviceActions.getMtmaActions());
        this.mtmaUnitsSub = this.mtmaUnits$.subscribe(mtmaUnits => {
            this.mtmaUnits = mtmaUnits;
            this.expandedRows = {};
            this.unitssLoading = false;
        });

        this.mtmaUnitsPaginationSub = this.mtmaUnitsPagination$
            .pipe(filter(p => !!p))
            .subscribe(paging => {
                this.totalRecords = paging.TotalCount;
            });

        this.mtmaUnitsMaxDataSub = this.mtmaUnitsMaxData$
            .pipe(filter(p => !!p))
            .subscribe(mtmaUnitsMaxData => {
                this.memorySize = mtmaUnitsMaxData.Current;
                this.maxMemorySize = mtmaUnitsMaxData.Max;
            });

        /*this.filterSub = this.filterForm.controls.searchFilter.valueChanges.pipe(
            debounceTime(500),
            map(v => v.trim().toLowerCase())
        ).subscribe(value => {
            this.filter = value;
            this.paginator.firstPage();
            this.dispatchGetUnits();
        });*/

        this.mtmaUnitModifySub = this.mtmaUnitModify$
            .pipe(filter(mtmaContactModifySub => !!mtmaContactModifySub))
            .subscribe(() => {
                this.dispatchGetUnits();
            });

        this.mtmaActiveTaskSub = this.mtmaActiveTask$.subscribe(mtmaActiveTask => {
            if (mtmaActiveTask.Id !== '') {
                this.isActiveTask = true;
            } else {
                this.isActiveTask = false;
            }
        });
        this.tabIndexSub = this.tabIndex$?.subscribe(
            async (tabIndex: number) => {
                this.tabIndex = tabIndex;
                this.dispatchGetUnits();
            });

        this.onResize();
    }

    ngOnDestroy(): void {
        this.mtmaUnitsPaginationSub?.unsubscribe();
        this.mtmaUnitsPaginationSub?.unsubscribe();
        this.mtmaUnitsMaxDataSub?.unsubscribe();
        this.mtmaUnitModifySub?.unsubscribe();
        this.mtmaActiveTaskSub?.unsubscribe();
        this.tabIndexSub?.unsubscribe();
    }

    dispatchGetUnits(): void {
        if (this.isSelectTab()) {
            this.store.dispatch(DeviceActions.getMtmaUnits({
                filter: this.filter,
                sort: this.paging.sort, order: this.paging.order, size: this.paging.size, page: this.paging.page
            }));
        }
    }

    isMtmaConnect(): boolean {
        //return (this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.MTMACONNECT) && this.tabIndex === 9); // TAB INDEX FOR MTMACONNECT CALLLOG IS 9
        return (this.tabIndex === 3); // TAB INDEX FOR MTMACONNECT IS 3 tab only for mtma

    }

    isSelectTab(): boolean {
        return this.isMtmaConnect();
    }


    addUnit(): void {
        this.store.dispatch(DeviceActions.resetUnitForm());
        this.ref = this.dialogService.open(MtmaUnitDialogComponent, {
            header: this.translate.instant('ADD_UNIT'),
            width: '60vw',
            breakpoints: { '1600px': '98vw' },
            contentStyle: { overflow: 'auto' },
        });
    }

    edit(unit: MtmaUnit): void {
        this.store.dispatch(DeviceActions.resetUnitForm());
        this.ref = this.dialogService.open(MtmaUnitDialogComponent, {
            header: this.translate.instant('EDIT_UNIT'),
            width: '60vw',
            breakpoints: { '1600px': '98vw' },
            contentStyle: { overflow: 'auto' },
            data: {
                unit
            },
        });
    }

    delete(unit: MtmaUnit): void {
        this.acceptButtonStyle = "p-button-danger";
        this.rejectButtonStyle = "p-button-secondary";
        this.confirmationService.confirm({
            header: this.translate.instant('DELETE_UNIT'),
            message: this.translate.instant('DELETE_UNIT_WARNING'),
            acceptLabel: this.translate.instant('CONFIRM'),
            rejectLabel: this.translate.instant('CANCEL'),
            icon: 'pi cm-alert',
            accept: () => {
                this.store.dispatch(DeviceActions.deleteMtmaUnit({ unitId: unit.ObjId }));
            },
            reject: () => {
            }
        });
    }

    loadUnits(event: TableLazyLoadEvent) {
        this.unitssLoading = true;

        this.paging = pageSortChange(this.paging, event);

        this.dispatchGetUnits();
    }

    getContactUnits(element: MtmaUnit) {
        if ((!element.ContactsInfo || element.ContactsInfo.length === 0) && element.Contacts && element.Contacts.length > 0) {
            this.store.dispatch(DeviceActions.getMtmaUnit({ unit: element }));
        }
    }

    getRuleData(element: MtmaContactUnit): string {
        let txt = '';
        if (element.RuleId !== undefined && element.RuleId !== null) {
            txt = ' - ' + element.RuleName;
            if (element.DtFrom !== undefined && element.DtTo !== undefined) {
                txt = txt + ' - ' + this.translate.instant('FROM') + ' ' + this.dateTransform.transform(element.DtFrom, 'dd/MM/yyyy HH:mm') +
                    ' - ' + this.translate.instant('TO') + ' ' + this.dateTransform.transform(element.DtTo, 'dd/MM/yyyy HH:mm');
            }
        }
        return txt;
    }

    getValueMemory(): number {
        return Math.ceil((this.memorySize / this.maxMemorySize) * 100);
    }

    // Design
    @HostListener('window:resize')
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    onExtendedMobile() {
        return StandardPageLayout.onExtendedMobile(this.screenWidth);
    }

    actionLayout(position: string): string {
        return StandardMtmaLayout.actionLayout(this.screenWidth, position);
    }

    layoutMarginResponsive(): string {
        return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
    }

    dynamicInputTextWidth(): string {
        return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
    }

    dynamicInputSearchWidth(): string {
        return StandardMtmaLayout.dynamicInputSearchWidth(this.screenWidth, 'w-25rem');
    }
}
